
import { defineComponent, PropType } from 'vue'

import { VideoCategoryAttributes } from '@/types/models/video-category'
import { toArray } from '@/utils/array'

export default defineComponent({
  props: {
    videoCategories: {
      type: Array as PropType<VideoCategoryAttributes[] | undefined>,
      'default': () => ([]),
    },
    allCategoriesLink: {
      type: Boolean,
      'default': () => (false),
    }
  },
  setup() {
    return {
      toArray
    }
  },
})
